import { useLayoutEffect, useState } from 'react';
import { throttle } from 'lodash';

const useSize = (ref) => {
  const [size, setSize] = useState(0);
  let containerResizeObserver;

  const updateSize = () => {
    setSize(ref.current.clientWidth);
  };

  useLayoutEffect(() => {
    if (!ref?.current || containerResizeObserver) {
      return;
    }
    if (('ResizeObserver' in window)) {
      containerResizeObserver = new window.ResizeObserver(throttle(updateSize, 200));
      containerResizeObserver.observe(ref.current);
    } else {
      window.addEventListener('resize', throttle(updateSize, 200));
    }
    updateSize();

    return () => {
      window.removeEventListener('resize', updateSize);
      return containerResizeObserver?.unobserve(ref.current);
    };
  }, [ref.current]);

  return size;
};

export default useSize;
